import { Separator } from './styles'

export function SelectSeparator() {
  return <Separator />
}
